import * as S from "./styles";
import { FieldText } from "../../components/FieldText";
import { Loading } from "../../components/Loading";
import CustomTableIonListado from "../../components/CustomTableIonListado";
import { FieldListSearch } from "../../components/FieldListSearch";
import { FieldList } from "../../components/FieldList";
import { FieldNumber } from "../../components/FieldNumber";
import { SummaryTable } from "../../components/Ion/SummaryTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faUpload, faFileExport, faCheckSquare, faSquare, faFileInvoice } from "@fortawesome/free-solid-svg-icons";
import { FieldDate } from "../../components/FieldDate";

//region EngagedSectionComponent
export const EngagedSectionComponent = ({
  loading,
  engagedFormData,
  setEngagedFormData,
  openPopUpLoadFile,
  permissions,
  exercise,
  area,
  handleSendEngaged,
  handleEngagedDataChange,
  exportEngagedData,
  cargarArchivoComprometidoRevisado,
  openPopUpLoadFileComprometidoRevisado,
  cargarComprometidoRevisado,
  totalStatusSummary,
  recalcularProrrateos,
  isAdminIon,
  isCoordinadorIon,
  typeBillable,
  handleTypeBillableSelect,
  billableDates,
  handleBillableDatesChange,
  listTypeFacturable,
  facturable,
  handleFacturableSelect,
  listFacturable,
}) => (
  <>
    <Loading hidden={!loading} />
    <S.AccordionContent twoColumns>
      <S.LeftColumn>
        <S.AccordionSectionComprometido1>
          <FieldText
            id="engaged"
            type="text"
            value={engagedFormData.engagedFileName || ""}
            handleChange={() => setEngagedFormData(engagedFormData)}
            label="Comprometido"
            styles="accordion"
          />
          <S.Buttons>
            <button
              onClick={openPopUpLoadFile}
              disabled={!permissions?.IONComprometido?.Editar}
            >
              <FontAwesomeIcon icon={faUpload} size="lg" />
              Cargar Fichero
            </button>
          </S.Buttons>
          <S.Buttons>
            <button
              disabled={
                !!!engagedFormData.engagedFileName ||
                !!!exercise ||
                !!!area ||
                !permissions?.IONComprometido?.Editar
              }
              onClick={handleSendEngaged}
            >
              <FontAwesomeIcon icon={faPlusCircle} size="lg" />
              Cargar Comprometido
            </button>
          </S.Buttons>
          {(isAdminIon || isCoordinadorIon) && (
            <S.Checkboxes className="checkbox">
              <input
                id="prorrateo"
                type="checkbox"
                checked={engagedFormData.prorrateo ? true : false}
                onChange={(e) => {
                  handleEngagedDataChange(e.target.checked, "prorrateo");
                }}
                disabled={!permissions?.IONComprometido?.Editar}
              />
              <label htmlFor="prorrateo" className="checkbox">
                Prorratear
              </label>
            </S.Checkboxes>
          )}
        </S.AccordionSectionComprometido1>

        <S.AccordionSectionComprometido2>
          <S.AccordionSectionComprometido2Inputs>
            <S.Checkboxes>
              <input
                id="exportAmount"
                type="checkbox"
                checked={engagedFormData.exportAmount ? true : false}
                onChange={(e) => {
                  handleEngagedDataChange(e.target.checked, "exportAmount");
                }}
                disabled={!permissions?.IONComprometido?.Editar}
              />
              <label htmlFor="exportAmount" className="checkbox">
                Exportar Acumulado
              </label>
            </S.Checkboxes>

            <S.Checkboxes>
              <input
                id="exportGestor"
                type="checkbox"
                checked={engagedFormData.exportGestor ? true : false}
                onChange={(e) => {
                  handleEngagedDataChange(e.target.checked, "exportGestor");
                }}
                disabled={!permissions?.IONComprometido?.Editar}
              />
              <label htmlFor="exportGestor" className="checkbox">
                Exportar Gestor
              </label>
            </S.Checkboxes>
            <S.InputListFacturado>
              <FieldList
                id="facturable"
                type="enum"
                label="Facturable"
                currentOption={facturable}
                handleChange={handleFacturableSelect}
                options={listFacturable.Valores}
                canBeEmpty={true}
                readOnly={false}
                required={false}
              />
            </S.InputListFacturado>
            <S.InputListFacturable>
              <FieldList
                id="typeBillable"
                type="enum"
                label="Tipo de facturable"
                currentOption={typeBillable}
                handleChange={handleTypeBillableSelect}
                options={listTypeFacturable.Valores}
                canBeEmpty={true}
                readOnly={false}
                required={false}
              />
            </S.InputListFacturable>
            <S.InputsDate>
              <FieldDate
                key="fechaDesde"
                id="fechaDesde"
                label="Fecha desde comprometido"
                value={billableDates?.fechaDesde || ""}
                handleChange={(id, e) => {
                  handleBillableDatesChange("fechaDesde", e);
                }}
                readOnly={false}
                required={false}
                styles="filter"
              />
              <FieldDate
                key="fechaHasta"
                id="fechaHasta"
                label="Fecha hasta comprometido"
                value={billableDates?.fechaHasta || ""}
                handleChange={(id, e) => {
                  handleBillableDatesChange("fechaHasta", e);
                }}
                readOnly={false}
                required={false}
                styles="filter"
              />
            </S.InputsDate>
          </S.AccordionSectionComprometido2Inputs>
          <S.Buttons>
            <button
              disabled={
                !permissions?.IONComprometido?.Exportar ||
                (!engagedFormData.exportAmount && !engagedFormData.exportGestor)
              }
              onClick={exportEngagedData}
            >
              <FontAwesomeIcon icon={faPlusCircle} size="lg" />
              Exportar Datos Comprometidos
            </button>
          </S.Buttons>
        </S.AccordionSectionComprometido2>

        <S.AccordionSectionComprometido3>
          <FieldText
            id="engagedReviewed"
            type="text"
            value={
              cargarArchivoComprometidoRevisado.engagedFileName
                ? cargarArchivoComprometidoRevisado.engagedFileName
                : ""
            }
            handleChange={() => setEngagedFormData(engagedFormData)}
            label="Comprometido Revisado"
            styles="accordion"
          />
          <S.Buttons>
            <button
              onClick={openPopUpLoadFileComprometidoRevisado}
              disabled={!permissions?.IONComprometido?.Editar}
            >
              <FontAwesomeIcon icon={faUpload} size="lg" />
              Cargar Fichero
            </button>
          </S.Buttons>
          <S.Buttons>
            <button
              disabled={
                !!!cargarArchivoComprometidoRevisado.engagedFileName ||
                !!!exercise ||
                !!!area ||
                !permissions?.IONComprometido?.Exportar
              }
              onClick={cargarComprometidoRevisado}
            >
              <FontAwesomeIcon icon={faPlusCircle} size="lg" />
              Cargar Comprometido revisado
            </button>
          </S.Buttons>
          {isAdminIon && (
            <S.Checkboxes>
              <input
                id="saltarValidaciones"
                type="checkbox"
                checked={engagedFormData.skipValidations ? true : false}
                onChange={(e) => {
                  handleEngagedDataChange(e.target.checked, "skipValidations");
                }}
              />
              <label htmlFor="saltarValidaciones" className="checkbox">
                Saltar validaciones
              </label>
            </S.Checkboxes>
          )}
        </S.AccordionSectionComprometido3>

        {(isAdminIon || isCoordinadorIon) && (
          <S.AccordionSectionComprometido4>
            <S.Buttons>
              <button
                onClick={recalcularProrrateos}
                disabled={!permissions?.IONComprometido?.Editar}
              >
                Recalcular Prorrateos
              </button>
            </S.Buttons>
          </S.AccordionSectionComprometido4>
        )}
      </S.LeftColumn>

      <S.RightColumn>
        <S.AccordionSectionComprometidoResumen>
          <SummaryTable totalStatusSummary={totalStatusSummary} />
        </S.AccordionSectionComprometidoResumen>
      </S.RightColumn>
    </S.AccordionContent>
  </>
);

//region BillableSectionComponent
export const BillableSectionComponent = ({
  loading,
  suplier,
  handleSupplierSelect,
  area,
  handleLoadBillable,
  permissions,
  exportOptionsState: { exportOptions, setExportOptions },
  handleExportSelected,
  totalStatusSummary,
}) => {
  const billableType = [
    { id: "PF", label: "Prefacturas PF" },
    { id: "SP", label: "Suplidos SP" },
    { id: "FD", label: "Factura Directa FD" },
    { id: "NF", label: "No Facturable NF" },
    { id: "SF", label: "Sin Factura SF" },
  ];

  return (
    <>
      <Loading hidden={!loading} />
      <S.AccordionContent twoColumnsAsymmetric>
        <S.LeftColumn>
          <S.AccordionSectionFacturable1>
            <S.Buttons billableSection>
              <button
                onClick={handleLoadBillable}
                disabled={!permissions?.IONFacturable?.Exportar}
              >
                <FontAwesomeIcon icon={faPlusCircle} size="lg" />
                Cargar Facturable
              </button>
            </S.Buttons>
          </S.AccordionSectionFacturable1>
        </S.LeftColumn>

        <S.RightColumn>
          <S.AccordionSectionFacturable2>
            <S.FieldListSearchWrapper>
              <FieldListSearch
                id="BillableProveedor"
                label="Proveedor"
                listName="ProveedoresION"
                currentOption={suplier}
                handleChange={handleSupplierSelect}
                canBeEmpty={true}
                readOnly={false}
                required={false}
                parent={"Area"}
                idParent={area}
              />
            </S.FieldListSearchWrapper>

            <S.Buttons billableSection>
              <button
                onClick={handleExportSelected}
                disabled={
                  !exportOptions.PF &&
                  !exportOptions.SP &&
                  !exportOptions.FD &&
                  !exportOptions.NF &&
                  !exportOptions.SF
                }
              >
                <FontAwesomeIcon icon={faFileExport} size="lg" />
                Exportar
              </button>
            </S.Buttons>

            <S.CheckboxesVertical>
              {billableType.map((bt) => {
                const hasBillableType = totalStatusSummary.some(
                  (e) => e.TipoFacturable === bt.id
                );

                return (
                  <S.Checkbox
                    key={bt.id}
                    title={hasBillableType ? "" : "No hay registros"}
                  >
                    <input
                      id={bt.id}
                      type="checkbox"
                      checked={exportOptions[bt.id] || false}
                      onChange={(e) =>
                        setExportOptions({
                          ...exportOptions,
                          [bt.id]: e.target.checked,
                        })
                      }
                      disabled={!hasBillableType}
                    />
                    <label htmlFor={bt.id} className="checkbox">
                      {bt.label}
                    </label>
                  </S.Checkbox>
                );
              })}
            </S.CheckboxesVertical>

            <S.CheckboxesVertical>
              {exportOptions.PF && (
                <S.Checkbox>
                  <input
                    id="cargaDirectaPF"
                    type="checkbox"
                    checked={exportOptions.CDPF}
                    onChange={(e) =>
                      setExportOptions({
                        ...exportOptions,
                        CDPF: e.target.checked,
                      })
                    }
                  />
                  <label htmlFor="cargaDirectaPF" className="checkbox">
                    Carga Directa PF
                  </label>
                </S.Checkbox>
              )}
            </S.CheckboxesVertical>
          </S.AccordionSectionFacturable2>
        </S.RightColumn>
      </S.AccordionContent>
    </>
  );
};

//region ListSectionComponent
export const ListSectionComponent = ({
  loading,
  suplierFilter,
  handleSupplierFilterSelect,
  area,
  metadataRegisters,
  registers,
  page,
  setPage,
  listSize,
  stateOT,
  stateOTList,
  handleStateOTSelect,
  numberOT,
  handleChangeNumberOT,
  sociedad,
  handleChangeSociedad,
  sociedadList,
  fecComprDesde,
  setFecComprDesde,
  fecComprHasta,
  setFecComprHasta,
  facturado,
  setFacturado,
  validado,
  setValidado,
  exportado,
  setExportado,
  setModalRequest,
  setSelected,
  actualizarSeleccionado,
  permissions,
  familiaList,
  conceptoList,
  familiaSelected,
  conceptoSelected,
  handleChangeFamilia,
  handleChangeConcepto,
  showValidarComprometidos,
  showDesValidarComprometidos,
  showFacturarComprometidos,
  showExportarComprometidos,
  hayFiltroSeleccionado,
  seleccionFiltro,
  setSeleccionFiltro,
  numeroFacturable,
  setNumeroFacturable
}) => (
  <>
    <Loading hidden={!loading} />
    <S.AccordionContent>
      <S.AccordionSectionListado>        
          <S.Filters count={5}>
            <FieldListSearch
              id="ListSectionProveedor"
              label="Proveedor"
              listName="ProveedoresION"
              currentOption={suplierFilter}
              handleChange={handleSupplierFilterSelect}
              canBeEmpty={true}
              readOnly={false}
              required={false}
              parent={"Area"}
              idParent={area}
            />

            <FieldList
              id="stateOT"
              type="enum"
              label="Estado OT"
              currentOption={stateOT}
              options={stateOTList}
              handleChange={handleStateOTSelect}
              canBeEmpty={true}
              readOnly={false}
              required={false}
            />

            <FieldNumber
              id="numberOT"
              label="Número OT"
              value={numberOT || 0}
              empty={numberOT === ""}
              handleChange={handleChangeNumberOT}
              type="int"
              readOnly={false}
              required={false}
              styles="filter"
            />

            <FieldList
                  id="familia"
                  type="enum"
                  label="Familia"
                  currentOption={familiaSelected}
                  options={familiaList}
                  handleChange={handleChangeFamilia}
                  canBeEmpty={true}
                  readOnly={false}
                  required={false}
            />
              
              <FieldList
                  id="concepto"
                  type="enum"
                  label="Concepto"
                  currentOption={conceptoSelected}
                  options={conceptoList}
                  handleChange={handleChangeConcepto}
                  canBeEmpty={true}
                  readOnly={false}
                  required={false}
            />

            <FieldList
              id="ListSectionSociedades"
              label="Sociedades"
              handleChange={handleChangeSociedad}
              currentOption={sociedad}
              options={sociedadList}
              type="enum"
              canBeEmpty={true}
              readOnly={false}
              required={false}
            />
            <FieldText
              id="numeroFacturable"
              label="Número Facturable"
              value={numeroFacturable}
              handleChange={(_, v) => setNumeroFacturable(v)}
              readOnly={false}
              required={false}
              styles="filter"
            />
            <S.InputsDateFilter>
              <FieldDate
                id="fecComprDesde"
                label="Fecha Comprometido Desde"
                value={fecComprDesde}
                empty={fecComprDesde === ""}
                handleChange={(_, v) => setFecComprDesde(v)}
                readOnly={false}
                required={false}
                styles="filter"
              />

              <FieldDate
                id="fecComprHasta"
                label="Fecha Comprometido Hasta"
                value={fecComprHasta}
                empty={fecComprHasta === ""}
                handleChange={(_, v) => setFecComprHasta(v)}
                readOnly={false}
                required={false}
                styles="filter"
              />
            </S.InputsDateFilter>
            <S.TriStateListsContainer>
              <FieldList
                id="validado"
                type="enum"
                label="Validado"
                currentOption={validado}
                options={[
                  { value: true, label: "Sí" },
                  { value: false, label: "No" },
                ]}
                handleChange={(_, e) =>
                  setValidado({
                    value: typeof e.Valor === "boolean" ? e.Valor : "",
                    label: e.Etiqueta,
                  })
                }
                canBeEmpty={true}
                readOnly={false}
                required={false}
              />

              <FieldList
                id="facturado"
                type="enum"
                label="Facturado"
                currentOption={facturado}
                options={[
                  { value: true, label: "Sí" },
                  { value: false, label: "No" },
                ]}
                handleChange={(_, e) =>
                  setFacturado({
                    value: typeof e.Valor === "boolean" ? e.Valor : "",
                    label: e.Etiqueta,
                  })
                }
                canBeEmpty={true}
                readOnly={false}
                required={false}
              />

              <FieldList
                id="exportado"
                type="enum"
                label="Exportado"
                currentOption={exportado}
                options={[
                  { value: true, label: "Sí" },
                  { value: false, label: "No" },
                ]}
                handleChange={(_, e) =>
                  setExportado({
                    value: typeof e.Valor === "boolean" ? e.Valor : "",
                    label: e.Etiqueta,
                  })
                }
                canBeEmpty={true}
                readOnly={false}
                required={false}
              />

               
            </S.TriStateListsContainer>

          </S.Filters>
          <S.ButtonsList listSection>
            <button
              onClick={() => setModalRequest("cargarComprometido")}
              disabled={!permissions.IONComprometido?.Editar}
            >
              <FontAwesomeIcon icon={faPlusCircle} size="lg" />
              Cargar Comprometidos
            </button>
            <button
              onClick={() => showValidarComprometidos()}
              disabled={!permissions.IONComprometido?.Editar}
            >
              <FontAwesomeIcon icon={faCheckSquare} size="lg" />
              Validar
            </button>
            <button
              onClick={() => showDesValidarComprometidos()}
              disabled={!permissions.IONComprometido?.Editar}
            >
              <FontAwesomeIcon icon={faSquare} size="lg" />
              Des-Validar
            </button>
            <button
              onClick={() => showFacturarComprometidos()}
              disabled={!permissions.IONComprometido?.Editar}
            >
              <FontAwesomeIcon icon={faFileInvoice} size="lg" />
              Facturar
            </button>
            <button
              onClick={() => showExportarComprometidos()}
              disabled={!permissions.IONComprometido?.Editar}
            >
              <FontAwesomeIcon icon={faFileExport} size="lg" />
              Exportar
            </button>
            <S.Checkboxes>
              <input
                id="selectFilter"
                type="checkbox"
                checked={seleccionFiltro ?? false}
                onChange={(e) => setSeleccionFiltro(e.target.checked)}
                disabled={!hayFiltroSeleccionado}
              />
              <label htmlFor="selectFilter" className="checkbox">
                Seleccionar Filtro
              </label>
            </S.Checkboxes>
          </S.ButtonsList>
          <CustomTableIonListado
            metadataRegisters={metadataRegisters}
            data={registers}
            page={page}
            setPage={setPage}
            listSize={listSize}
            setModalRequest={setModalRequest}
            setSelected={setSelected}
            actualizarSeleccionado={actualizarSeleccionado}
            permissions={permissions}
          />        
      </S.AccordionSectionListado>
    </S.AccordionContent>
  </>
);
